import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=696e4aae&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=696e4aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e4aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696e4aae')) {
      api.createRecord('696e4aae', component.options)
    } else {
      api.reload('696e4aae', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=696e4aae&scoped=true&", function () {
      api.rerender('696e4aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xGD5lfQhFdZh/JS/comp/GuestBox.vue"
export default component.exports